module.exports = __webpack_public_path__ + "s.no1.88710fab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/s.no1.jpg
// module id = ir13
// module chunks = 0